import { createContext } from 'react';
import { create } from 'zustand'
import { getSystemAlertsUnreadCount, SeverityType } from '../api/alertsApi';
import { Guid } from '../api/baseApi';
import { currentUserHasPermission, Permission } from '../api/authApi';


interface CounterState {
    totalAlerts: number,
    messages: NewAlertMessage [],
    update: () => void,
    removeMessage: (id:Guid) => void,
    start: () => void,
    timer: NodeJS.Timer | null,
    pause: () => void,
    stop: () => void,
    isRunning: boolean,
    alreadyShowed: Guid[],
    onShow: (id:Guid)=>void,
    isShow: (id:Guid)=>boolean,
    resetIsShown: () => void,
}

export interface NewAlertMessage {
    id: Guid,
    message: string, 
    severity: SeverityType
}

const isExternalOrganisationUser = () => currentUserHasPermission(Permission.ExternalOrganisationUser);

export const useAlertsCountStore = create<CounterState>((set, get) => ({
    totalAlerts: 0,
    messages: [],
    alreadyShowed: [],
    timer: null,
    isRunning: false,
    update: async () => { 
        if (isExternalOrganisationUser()) {
            set({ totalAlerts: 0, messages: [] });
            return;
        }

        var totalAlerts = await getSystemAlertsUnreadCount();
        if(totalAlerts.type === "succes"){
            set({ 
                totalAlerts: totalAlerts.data.data.count, 
                messages:[...get().messages, ...totalAlerts.data.data.newMessages]
            })
        }
        
    },
    onShow: (id:Guid)=> {
        set({
            alreadyShowed: [...get().alreadyShowed, id]
        })
    },
    isShow: (id:Guid) => {
        return !get().alreadyShowed.some( it => it === id)
    },
    resetIsShown: () => {
        set({
            alreadyShowed: []
        })
    },
    removeMessage: (id: Guid) => {
        set({
            messages: get().messages.filter( it => it.id != id)
        })
    },
    start : () => { 
        if (isExternalOrganisationUser()) {
            let currentTimer = get().timer;
            if(currentTimer){
                clearInterval(currentTimer);
            }
            set({ isRunning: false, timer: null, totalAlerts: 0, messages: [] });
            return;
        }

        let state = get();
        set({ isRunning: true})

        if(!state.timer){
            let newTimer = setInterval(() => { if(get().isRunning){state.update()} }, 15000);
            get().update();
            set({timer: newTimer});
        }
    },
    pause: () => {set({ isRunning: false})},
    stop: () => {
        let currentTimer = get().timer;
        if(currentTimer){
            clearInterval(currentTimer)
            set({ isRunning: false, timer: null});
        }
    }
}))
